module.exports = __webpack_public_path__ + "img/sell.33acc932.png";